export default __webpack_public_path__ + "static/media/Ellipse 11.e9d5d985.png";